module.exports = __webpack_public_path__ + "img/color_block_5.165ab22c.svg";